import React, { useMemo } from "react";
import BaseChart from "../../components/ui/BaseChart";

const WEEKDAY_ORDER = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

const DayOfWeekChart = ({ data }) => {
  // Re-order from Sun-Sat → Mon-Sun and find the peak
  const ordered = useMemo(() => {
    if (!data?.length) return [];
    const map = Object.fromEntries(data.map((d) => [d.day, d.count]));
    return WEEKDAY_ORDER.map((day) => map[day] ?? 0);
  }, [data]);

  const peak = Math.max(...ordered, 1);

  const chartOptions = useMemo(
    () => ({
      chart: {
        type: "column",
        height: 370,
        margin: [16, 8, 30, 32],
        backgroundColor: "transparent",
      },
      title: { text: null },
      xAxis: {
        categories: WEEKDAY_ORDER,
        lineColor: "#e5e7eb",
        tickLength: 0,
        labels: { style: { fontSize: "10px", color: "#888" } },
      },
      yAxis: {
        title: { text: null },
        gridLineColor: "#f3f4f6",
        labels: { style: { fontSize: "10px", color: "#aaa" } },
        min: 0,
      },
      legend: { enabled: false },
      tooltip: {
        formatter() {
          return `<b>${this.x}</b>: ${this.y} work orders`;
        },
        backgroundColor: "#1e293b",
        style: { color: "#f8fafc" },
        borderWidth: 0,
        borderRadius: 6,
      },
      plotOptions: {
        column: {
          borderRadius: 4,
          borderWidth: 0,
          pointPadding: 0.08,
          groupPadding: 0.06,
          dataLabels: {
            enabled: false,
          },
        },
      },
      series: [
        {
          name: "Work Orders",
          data: ordered.map((count, i) => ({
            y: count,
            color: count === peak && peak > 0 ? "#0F40AE" : "#93C5FD",
          })),
        },
      ],
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ordered, peak],
  );

  if (!data?.length) return null;

  return (
    <div>
      <BaseChart options={chartOptions} className="w-full" />
      <p className="text-[10px] text-gray-400 text-center mt-1">
        Peak day:{" "}
        <span className="font-semibold text-[#0F40AE]">{WEEKDAY_ORDER[ordered.indexOf(peak)]}</span>{" "}
        ({peak} WOs)
      </p>
    </div>
  );
};

export default DayOfWeekChart;
